import { contractsPropertyContext } from '@/pages/property/contracts'
import { useContext } from 'react'
import { PropertySearchForm } from './PropertySearchForm'

export const ContractsPropertySearch = () => {
  const { updateFilter, filter } = useContext(contractsPropertyContext)

  return (
    <PropertySearchForm
      filter={filter}
      onSubmit={updateFilter}
      listType='contracted' />
  )
}